"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormField = void 0;
var core_1 = require("@material-ui/core");
var acid_components_1 = require("@michelin/acid-components");
var TextFieldUOM_1 = require("@michelin/acid-components/build/components/TextFieldUOM/TextFieldUOM");
var react_1 = __importDefault(require("react"));
var react_hook_form_1 = require("react-hook-form");
var DependentFormControlledSelect_1 = require("./DependentFormControlledSelect");
var FormControlledSelect_1 = require("./FormControlledSelect");
function FormField(props) {
    var _this = this;
    var _a, _b;
    var register = props.register, control = props.control, error = props.error, definition = props.definition, readOnly = props.readOnly;
    if (definition.options) {
        if (definition.dependencies) {
            return (react_1.default.createElement(DependentFormControlledSelect_1.DependentFormControlledSelect, { name: definition.name, rules: definition.rules, control: control, label: definition.label, options: definition.options, loading: definition.loading, readOnly: readOnly, error: error, helperText: error ? definition.helperText : undefined, dependencies: definition.dependencies, onDependenciesChanged: definition.onDependenciesChanged || (function () { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
                    return [2 /*return*/];
                }); }); }) }));
        }
        return (react_1.default.createElement(FormControlledSelect_1.FormControlledSelect, { name: definition.name, rules: definition.rules, control: control, label: definition.label, options: definition.options, loading: definition.loading, readOnly: readOnly, error: error, helperText: error ? definition.helperText : undefined }));
    }
    if (definition.uom) {
        return (react_1.default.createElement(react_hook_form_1.Controller, { control: control, name: definition.name, rules: definition.rules, render: function (_a) {
                var field = _a.field;
                return (react_1.default.createElement(acid_components_1.TextFieldUOM, { label: definition.label, error: error, helperText: error ? definition.helperText : undefined, inputProps: __assign({}, field), readOnly: readOnly, uom: definition.uom || TextFieldUOM_1.UOM.miles }));
            } }));
    }
    var isNumberField = (_a = definition.rules) === null || _a === void 0 ? void 0 : _a.valueAsNumber;
    return (react_1.default.createElement(core_1.TextField, { type: isNumberField ? 'number' : undefined, label: definition.label, error: error, helperText: error && definition.helperText, inputProps: __assign(__assign({}, register(definition.name, definition.rules)), { readOnly: readOnly, style: { textTransform: definition.forceUppercase ? 'uppercase' : undefined } }), required: !!((_b = definition.rules) === null || _b === void 0 ? void 0 : _b.required), InputLabelProps: {
            shrink: true,
        }, fullWidth: true }));
}
exports.FormField = FormField;
//# sourceMappingURL=FormField.js.map